<template>
  <div class="question">
    <a-spin class="load"
            v-show="loading" />
    <div class="top">
      <span class="icon"
            @click="goHistory"><img class="goHistory"
             src="../../assets/image/08.png"
             alt=""></span>
      <span class="iconText">问题归类</span>
    </div>
    <div class="content">
      <div class="contentUl">
        <div class="li"
             v-for="(item,index) in listData"
             :key="index">
          <div class="title">{{item.title}}</div>
          <div class="date">
            <span class="time">{{format.format(item.createDate)}}</span>
            <span class="num">共{{item.askSize}}个问题</span>
          </div>
          <!-- <div style="cursor:pointer;" @click="searchQuestion(item.id)">
                <span class="quesNum">共{{item.askSize}}个问题</span>
                <img class="quesImg" src="../../assets/image/a_right.png" alt="">
              </div> -->
        </div>
        <a-empty v-if="listData.length==0" />
      </div>
      <div v-if="listData.length!=0" style="text-align:center;margin-top:15px;">
        <a-config-provider>
          <a-pagination :default-current="1"
                        :page-size="pageSize"
                        @change="handleListChange"
                        :total='total' />
        </a-config-provider>
      </div>
    </div>
  </div>
</template>
<script>
import format from '../../utils/format.js'
export default {
  name: 'ClassifyQuestion',
  data () {
    return {
      format,
      loading: false,
      listData: [],
      pageSize: 5,
      pageNum: 1,
      total: 0
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    goHistory () {
      this.$router.go(-1)
    },
    handleListChange (current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getList()
    },
    getList () {
      const param = {
        userId: this.$getUserInfo().id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getAskClassificationPage',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listData = res.resultData.list
          this.total = res.resultData.total
        }
      })
    },
    searchQuestion (id) {
      this.$router.push({ name: 'ClassifyQuestionDetail', params: { id: id } })
    }
  }

}
</script>
<style lang="less" scoped>
ul li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.question {
  position: relative;
  .load {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%, 50%);
  }
  .top {
    height: 110px;
    background-color: #fff;
    position: relative;
    padding: 0 50px;
    .goHistory {
      width: 16px;
      height: 32px;
      cursor: pointer;
    }
    .icon {
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 50px;
    }
    .iconText {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 100px;
      color: #9d9292;
      font-size: 24px;
    }
  }
  .content {
    width: 1240px;
    margin: 0 auto;
    .contentUl {
      .li {
        height: 170px;
        width: 100%;
        background: #fff;
        margin-top: 15px;
        border-radius: 12px;
        padding: 30px;
        .title {
          font-size: 18px;
          color: #040506;
        }
        .date {
          color: #9d9292;
          text-align: left;
          font-size: 14px;
          margin-top: 10px;
        }
        .num {
          float: right;
          font-size: 16px;
          color: @primary-color;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
